import { render, staticRenderFns } from "./EditLandingPageFields.vue?vue&type=template&id=1f04ed90&scoped=true&"
import script from "./EditLandingPageFields.vue?vue&type=script&lang=ts&"
export * from "./EditLandingPageFields.vue?vue&type=script&lang=ts&"
import style0 from "./EditLandingPageFields.vue?vue&type=style&index=0&id=1f04ed90&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04ed90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCardText,VContainer,VDataTable,VIcon,VSimpleCheckbox,VSpacer})
